import { Box, styled } from '@mui/material';

export const CardHeaderStyled = styled(Box)({
  width: '100%',
  padding: '24px 24px 0',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const ActionsStyled = styled(Box)({
  gap: '8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
});
